import invariant from 'invariant';

import Bot from './Bot';
import RandomCardBot from './bots/RandomCardBot';
// import TutorialBot from '../bots/TutorialBot';
import { BidPreferences, CardValuePreferences } from './AIUtilities';
import BasicBot from './bots/BasicBot';
import EasyBot from './bots/EasyBot';
import TutorialBot from './bots/TutorialBot';
import { CardAffinity } from './CardTypes';
import Game from './Game';
import { Resource } from './Resources';

export type BotDisplayMode = 'devOnly' | 'hidden' | 'visible';
export type BotDisplayData = {
  bot: Bot;
  name: string;
  displayMode: BotDisplayMode;
};
export const PlayableBots: { [key: string]: BotDisplayData } = {
  easy_bot: {
    bot: new EasyBot(),
    name: 'Easy Bot',
    displayMode: 'visible',
  },
  basic_bot: {
    bot: new BasicBot(),
    name: 'Advanced Bot',
    displayMode: 'visible',
  },
  basic_bot2: {
    bot: new BasicBot(
      {
        tribute_value: 1,
        card_output_values_by_age: {
          gold: [0.5, 0.5, 0.5],
          military: [0.5, 0.5, 0.25],
        } as Record<Resource, number[]>,
        random_value_range: [0, 0.001],
        target_gold_output_by_age: [4, 7, 8],
        military_supremacy_target: 1,
        military_supremacy_preference: 0.5,
        card_flat_favor_preference_by_age: [1, 1.5, 2],
        target_card_type_by_age: {
          [CardAffinity.Leader]: [1, 1, 1],
          [CardAffinity.Basic]: [0, 0, 0],
          [CardAffinity.Derion]: [2, 4, 5],
          [CardAffinity.Tyros]: [2, 3, 5],
          [CardAffinity.Zeona]: [1, 3, 5],
        },
        card_cost_value_reduction_by_age: [0.01, 0.01, 0.01],
      } as CardValuePreferences,
      {
        conserve_military_factor_by_age: [0.005, 0.005, 0.005],
        bid_nothing_probability_by_age: [0.3, 0.3, 0.3],
        bid_nothing_threshold_by_age: [5, 5, 5],
      } as BidPreferences,
    ),
    name: 'Advanced Bot 2',
    displayMode: 'devOnly',
  },
  valid_move: {
    bot: new Bot(),
    name: 'Valid Move',
    displayMode: 'devOnly',
  },
  random_card: {
    bot: new RandomCardBot(),
    name: 'Random Card',
    displayMode: 'hidden',
  },
  tutorial: {
    bot: new TutorialBot(),
    name: 'Tutorial',
    displayMode: 'hidden',
  },
};

// Adds bot actions until no more can be added
export function addBotActions(game: Game): void {
  const MAX_ITERATIONS = 100;

  for (let i = 0; i < MAX_ITERATIONS; i++) {
    let action_added = false;

    for (const playerInfo of game.staticState.playerInfos) {
      const playerID = playerInfo.userID;
      const botType = playerInfo.botType;

      if (!botType) {
        continue;
      }

      if (game.serverState.readyByUserID[playerID]) {
        continue;
      }

      let bot = PlayableBots[botType as keyof typeof PlayableBots].bot;
      invariant(bot, 'bot type "%s" not found', botType);

      let action = bot.actionForGameState(game.computedState, playerID);

      if (action) {
        game.addAction(playerID, action);
        action_added = true;
      }
    }

    if (!action_added) {
      return;
    }
  }
}
